import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const IMAGES = {
  facade: "https://customer-assets.emergentagent.com/job_maison-prestige-3/artifacts/leivgr4d_shoootin-photo-24.jpg"
};

const HeroSection = () => {
  const { t } = useLanguage();

  const scrollToStats = () => {
    const statsSection = document.getElementById('intro');
    if (statsSection) {
      statsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative h-screen w-full overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.facade}
          alt="Villa contemporaine d'exception avec piscine chauffée et terrasse - Croissy-sur-Seine, Yvelines"
          className="w-full h-full object-cover"
          data-testid="hero-image"
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 hero-gradient" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 md:pb-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 w-full">
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.3, ease: 'easeOut' }}
          >
            {/* Tagline */}
            <p className="text-white/90 text-lg md:text-xl font-light italic mb-3 font-['Playfair_Display']">
              {t('hero_tagline')}
            </p>

            {/* Main Title */}
            <h1 
              className="text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-['Playfair_Display'] tracking-tight leading-[0.95] mb-4"
              data-testid="hero-title"
            >
              {t('hero_subtitle')}
            </h1>

            {/* Location */}
            <p 
              className="text-white/80 text-base md:text-lg font-light tracking-wide mb-8"
              data-testid="hero-location"
            >
              {t('hero_location')}
            </p>

            {/* CTA */}
            <button
              onClick={scrollToStats}
              className="group flex items-center gap-3 text-white hover:text-[#C5A059] transition-colors duration-300"
              data-testid="hero-cta-btn"
            >
              <span className="text-sm tracking-[0.15em] uppercase font-medium">
                {t('hero_cta')}
              </span>
              <ChevronDown className="w-5 h-5 animate-bounce" strokeWidth={1.5} />
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
